import bigDecimal from "js-big-decimal";
import { formatNumberWithZeroCount } from "utils";
import { useMemo } from "react";

interface UseFormatPriceProps {
  price: string;
  type: "token" | "stock" | "others";
}

/**
 *  通用处理 price 的hooks，已达到产品内业务的统一
 * 使用 BigDecimal 处理大数，避免精度丢失
 * @param price 价格
 * @param type 资产类型
 * @returns
 */
export const useFormatPrice = ({ price, type }: UseFormatPriceProps) => {
  const formatPrice = new bigDecimal(String(price)).getValue();
  const priceData = useMemo(() => {
    return formatNumberWithZeroCount({
      numStr: formatPrice,
      decimals: 6,
      minZeroCount: 4,
    });
  }, [formatPrice]);

  // 缓存左侧数字计算结果
  const leftDigits = useMemo(() => {
    if (!priceData?.isSuccess || type == "others") {
      return priceData?.leftDigits;
    }

    // 使用 BigDecimal 比较整数部分，避免大数精度丢失
    const integerPartStr = priceData.integerPart || "0";
    const integerPartBD = new bigDecimal(integerPartStr);
    const zeroBD = new bigDecimal("0");
    const integerPartCompare = integerPartBD.compareTo(zeroBD);

    if (integerPartCompare > 0 && priceData?.leftDigits?.length > 2) {
      return priceData.leftDigits?.substring(0, 2);
    } else if (integerPartCompare === 0 && priceData?.leftDigits?.length > 4) {
      // 使用 BigDecimal 比较前4位是否不为0
      const firstFourDigits = priceData.leftDigits?.substring(0, 4) || "0";
      const firstFourBD = new bigDecimal(firstFourDigits);
      const firstFourCompare = firstFourBD.compareTo(zeroBD);
      return firstFourCompare !== 0
        ? priceData.leftDigits?.substring(0, 4)
        : null;
    }
    return priceData?.leftDigits;
  }, [type, priceData]);

  return {
    priceData: { ...priceData, leftDigits },
  };
};
